module.exports = __webpack_public_path__ + "img/datos_generales.2a5dc658.svg";